import React from 'react';
import { Flex } from '@finect/tabular-core/Flex';
import { Spinner } from './../Spinner';
export var Loading = function Loading(props) {
  var height = props.height || '300px';
  return React.createElement(Flex, {
    style: {
      height: height
    },
    justify: "center",
    align: "center"
  }, React.createElement(Spinner, null));
};